import { Component, computed, inject } from '@angular/core';
import { ValidationMessageService } from '../../services/validation-message.service';
import { AlertToast } from '../../../../shared/components/alert-toast/alert-toast';

/**
 * Persistent top-of-page error when address validation cannot continue.
 */
@Component({
  selector: 'app-system-error-banner',
  imports: [AlertToast],
  templateUrl: './system-error-banner.html',
  host: { '[style.display]': 'messageText() ? null : "none"' },
})
export class SystemErrorBanner {
  private readonly validationMessages = inject(ValidationMessageService);

  protected readonly messageText = computed(() =>
    this.validationMessages.resolveSystemErrorText(this.validationMessages.systemError()),
  );
}
